/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_ParticipantBrokerAccountDto } from '../models/PagedResultDto_ParticipantBrokerAccountDto';
import type { Wealthlane_FinanceIntegrationService_Dtos_ParticipantBrokerAccountDtos_BrokerAccountDashboardDto } from '../models/Wealthlane_FinanceIntegrationService_Dtos_ParticipantBrokerAccountDtos_BrokerAccountDashboardDto';
import type { Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto } from '../models/Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto';
import type { Wealthlane_Shared_Hosting_Dtos_BrokerDto_ParticipantBrokerAccountListExportDto } from '../models/Wealthlane_Shared_Hosting_Dtos_BrokerDto_ParticipantBrokerAccountListExportDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantBrokerAccountService {

    /**
     * @param formData 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto OK
     * @throws ApiError
     */
    public static postApiFinanceIntegrationApiAppParticipantBrokerAccountImportParticipantBrokerAccount(
formData?: {
File?: Blob;
},
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/finance-integration/api/app/participant-broker-account/import-participant-broker-account',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static putApiFinanceIntegrationApiAppParticipantBrokerAccountBrokerageAccount(
requestBody?: Array<Wealthlane_Shared_Hosting_Dtos_BrokerDto_ParticipantBrokerAccountListExportDto>,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/finance-integration/api/app/participant-broker-account/brokerage-account',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_FinanceIntegrationService_Dtos_ParticipantBrokerAccountDtos_BrokerAccountDashboardDto OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppParticipantBrokerAccountAccountOpeningDashboard(): CancelablePromise<Array<Wealthlane_FinanceIntegrationService_Dtos_ParticipantBrokerAccountDtos_BrokerAccountDashboardDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/participant-broker-account/account-opening-dashboard',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyIds 
     * @param participantIds 
     * @param countryIds 
     * @param stateIds 
     * @param brokerStatusIds 
     * @param isOnboarded 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_ParticipantBrokerAccountDto OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppParticipantBrokerAccountParticipantBrokerAccountList(
companyIds?: Array<string>,
participantIds?: Array<string>,
countryIds?: Array<string>,
stateIds?: Array<string>,
brokerStatusIds?: Array<number>,
isOnboarded?: boolean,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_ParticipantBrokerAccountDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/participant-broker-account/participant-broker-account-list',
            query: {
                'CompanyIds': companyIds,
                'ParticipantIds': participantIds,
                'CountryIds': countryIds,
                'StateIds': stateIds,
                'BrokerStatusIds': brokerStatusIds,
                'IsOnboarded': isOnboarded,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
